const chut = "8?)i_~Nk7qv0IX;";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ViennaObject } from "../../interfaces/ViennaSection.interface";
import { ImageClassificationResponse } from "../../interfaces/ImageClassificationResponse.interface";
import { MechanicsService } from "./mechanics.service";
import * as CryptoJS from "crypto-js";
import { environment } from "../../environments/environment";
import { lastValueFrom } from "rxjs";

const minScore: number = 0.5; // Percentage of confidence to reach in order to get a star and put the section in blue

import { fromEvent, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

// Use this for dev, locally, when the classification API can't be contacted
// declare var require: any
// const mockResponse = require("./imports/mockResponse.json")

let mapping_version = {
	v8: "vienna8",
	v9: "vienna9",
};

@Injectable({
	providedIn: "root",
})
export class MainService {

	public base64: string = "";

	public editMode: boolean = false; // true = displays the image editor instead of the drop zone. Since it's an *ngIf, it also triggers the editor's constructor and init

	public originalBase64: string = ""; // to be able to reset, doesn't change

	public res: ImageClassificationResponse; // in case of language change, so we don't need to call the API again, we can just use the cached results

	public columnFilter: string = ""; // free input filter at the top of column2

	public selectedSections: ViennaObject[] = []; // I need an independent array for drag and drop :( I can't use the full allSections and just hide lines...

	public highestScores = {
		category: 0,
		section: 0,
	};

	public languageChangeObserver: Observable<any> = fromEvent(
		document,
		"wipoLanguageChange"
	).pipe(distinctUntilChanged()); // Converting document event to a public Observable, so I can subscribe/unsubscribe from anywhere

	constructor(public ms: MechanicsService, public http: HttpClient) {
		const l = `MAS.MAS constructor - `;

		this.languageChangeObserver.subscribe(async ($event) => {
			/*
					  In MAS and not in MS, bacause it calls this.sendImageData(), which can't be done from MS
				  */

			const l = `MAS.WIPO NAVBAR LANGUAGE CHANGE subscription - `;

			const lang = $event.detail && $event.detail.languageSelected;
			// console.log(`${l}WIPO Navbar Language change subscription triggered - incoming lang='${lang}' - FULL $event = `, $event);

			if (lang === this.ms.preferences.lang) {
				// console.log(`%c${l}Language is the same, not switching language`, 'color: #bada55')
				return;
			}

			// console.log(`%c${l}Switching language '${this.preferences.lang}' to '${lang}' `, "color:blue")
			this.ms.switchLang(lang); // will subsequently trigger ts.onLangChange, which will refresh the translations object
			this.ms.savePreferences();

			this.selectedSections = this.selectedSections.map((object) =>
				this.ms.allDivisionsAndSections.find(s => s.classification === object.classification)
			);

			// Need to reload all categories and sections in the new language, to rehydrate all objects, recreate all tooltips etc.
			await this.ms.buildStuff();

			// Need to reclassify the image (all ratings hve been lost when loading the categories in another language)
			await this.sendImageData();
		});

		const intervalRetry = setInterval(() => {
			if (!this.ms.preferences.lang) {
				return;
			}
			this.resetResults();
			clearInterval(intervalRetry);
		}, 200);
	}

	ngOnChanges(changes) {
		const l = `MAS.mas.ngOnChanges() - `;

		// console.log(`${l}changes=`, changes)
	}

	decrypt(crypted: any): any {
		const l = `MAS.decrypt() - `;

		/*
				Passed data should be a string.
				Will attempt to decrypt it.
				If can't decrypt, sends back the data as is.
				This makes the Angular app accept encrypted and non-encrypted responses from the server.
			*/

		//console.log(`${l}Received data to decrypt (type='${typeof(crypted)}') = `)

		if (typeof crypted !== "string") {
			// console.log(`${l}Data to decrypt = `, crypted)
			// console.log(`${l} - Data to decrypt is not a string, skipping`)
			return crypted;
		}

		// On Localhost, the data may not be encrypted, but the ResponseType is still "string", so we'll get a stringified JSON anyway. I need to simply parse it, without decryption

		let decrypted;

		try {
			decrypted = JSON.parse(crypted);
			return decrypted;
		} catch (err) {
			// console.log(`${l}Could not parse response directly as JSON, attempting to decrypt it.`)
		}

		// OK so now, I very likely have an encrypted string.

		// console.time(`${l}decryption took`)

		let originalStringified: string;

		try {
			const bytes: any = CryptoJS.AES.decrypt(crypted, chut);
			// console.log(crypted)
			originalStringified = bytes.toString(CryptoJS.enc.Utf8);

			// console.log(`${l}originalStringified=`, originalStringified)

			decrypted = JSON.parse(originalStringified);
		} catch (err) {
			console.log(err);
			console.log(
				`${l}Could not JSON.parse decrypted content. Probably not an object. Sending back decrypted string as is.`
			);
		}

		// console.timeEnd(`${l}decryption took`)

		return decrypted || originalStringified;
	}

	buildResults(): void {

		const l = `MAS.buildResults() - `

		let categoriesScores = {
			/*
			"1" : 28,
			"2" : 0.5
			*/
		}

		/*
			In addition to 3.15 and 19.10, the only other codes without Sections in VCL9 are:
			
			3.15 OTHER ANIMALS; LARGE PREHISTORIC ANIMALS, DINOSAURS
			3.17 GROUPS OF ANIMALS CLASSIFIED IN DIFFERENT DIVISIONS OF CATEGORY 3
			4.7 GROUPS OF FIGURATIVE ELEMENTS CLASSIFIED IN DIFFERENT DIVISIONS OF CATEGORY 4
			19.10 COFFINS, FUNERARY URNS
			19.19 REPRESENTATIONS OF MISCELLANEOUS PRODUCTS
			
			And of course, everything in Category 28:
			
			28.1  INSCRIPTIONS IN ARABIC CHARACTERS
			28.3  INSCRIPTIONS IN CHINESE, JAPANESE OR KOREAN CHARACTERS
			28.5  INSCRIPTIONS IN CYRILLIC CHARACTERS
			28.7  INSCRIPTIONS IN GREEK CHARACTERS
			28.9  INSCRIPTIONS IN HEBREW CHARACTERS
			28.11  INSCRIPTIONS IN LATIN CHARACTERS
			28.17  INSCRIPTIONS IN HISTORICAL, CUNEIFORM OR HIEROGLYPHIC CHARACTERS
			28.19  INSCRIPTIONS IN OTHER CHARACTERS
		*/

		// Below : manually adding stuff to the classifier results, to test (dinosaurs etc)
		// this.res.classes.unshift("03.15.00") // OTHER ANIMALS; LARGE PREHISTORIC ANIMALS, DINOSAURS
		// this.res.classes.unshift("19.10.00") // COFFINS, FUNERARY URNS
		// this.res.classes.unshift("28.09.00")
		// this.res.weights.unshift(0.30)

		for (let index in this.res.classes) {

			let classificationString = this.res.classes[index].split("-")[0]; // "03.07.22-Hummingbirds" --> "03.07.22"

			let classificationArray: number[] = classificationString
				.split(".") // ["03","07","02"]
				.map(n => +n); // [3,7,2]

			classificationString = classificationArray.join("."); // "3.7.2"

			let section = this.ms.allSections.find(s => s.classification === classificationString)

			if (!section) {
				console.error(`${l} Did not find any section with classification "${classificationString}"`)
				continue
			}

			section.score = this.res.weights[index] || 0 // score == 0 means "not in the API results" but can still be displayed when filtering
			section.score *= 100 // looks nicer
			section.score = Number(section.score.toFixed(2))

			/*
				NEW 2024-01-26 Now we can mix divisions and sections (default), or use just the divisions, or just the sections.
				BUT the classificator does not send back divisions classifications (level 2), only sections (level 3).
				Christophe told me to use the results from the sections to compute a global score for the whole division.
			*/

			const divisionClass = classificationArray[0] + "." + classificationArray[1];
			const division = this.ms.allDivisions.find(d => d.classification === divisionClass);

			if (!division) {
				console.error(`${l} Did not find any division with classification "${divisionClass}" - ms.allDivisions = `, structuredClone(this.ms.allDivisions))
				continue
			}

			// console.log(`${l}Adding ${section.score} to divion ${division.classification} because ${this.res.classes[index]}`);

			division.score = (division.score || 0) + section.score;
			division.score = Number(division.score.toFixed(2))

			let category = classificationArray[0];

			categoriesScores[category] = (categoriesScores[category] || 0) + section.score;

		}

		// Now that all sections and all divisions have a "score" key, I concatenate them together to form allDivisionsAndSections
		this.ms.allDivisionsAndSections = this.ms.allDivisions.concat(this.ms.allSections);

		// Now sorting categories from categories results
		this.highestScores.category = 0

		for (let category of this.ms.allCategories) {

			category.score = categoriesScores[category.classification] || 0;

			if (category.score > 0 && category.score < 1) {
				category.score = +category.score.toFixed(1) // toFixed returns a bloody STRING -_-
			}

			if (category.score >= 1) {
				category.score = Math.floor(category.score + 0.5)
			}

			if (category.score > this.highestScores.category) this.highestScores.category = category.score
		}
	}

	call(route: string, payload = {}): Promise<any> {

		const l = `MAS.call() - `;

		this.ms.isLoading = true;

		let prefix = environment.apiPrefix;

		const headers = new HttpHeaders({
			Authorization: "Bearer 37538A20-D9B3-4D03-BDDA-4C310DAC2A30",
		});

		return lastValueFrom(
			this.http.post(prefix + route, payload, { headers, responseType: "text" })
		)
			.then((res: any) => {
				res = this.decrypt(res);
				this.ms.isLoading = false;

				if (this.ms.isLocalHost) {
					console.log(`${l}LOCALHOST LOG ONLY - res = `, res);
				}

				if (res.error) {
					console.log(res.error);
					throw res;
				}
				return res;
			})
			.catch((err) => {
				this.ms.isLoading = false;
				console.error("CALL error : ", err);
				alert(this.ms.translate("error calling api"));
			});
	}

	checkCategory(category?: ViennaObject): void {
		category = category || this.ms.allCategories[0];

		this.ms.selectedCategory = category;

		if (category.checked) return; // radio buttons!

		for (let category of this.ms.allCategories) category.checked = false;

		category.checked = true;

		category.visited = true;

		this.clearFilter();
	}

	checkObject({ classification = null, object = null, showToast = false }) {

		const l = `mas.checkObject() - `

		// console.log(`${l}Checking `, structuredClone(object));

		if (!classification && !object) {
			console.error(
				`mas.checkSection() - no classification and no section passed, can't check anything`
			);
		}

		// 1. Checks the corresponding section.

		// 2. If this section has one principal, also check this principal

		// 3. If the section has more than one principal
		// if at least one of these principal sections is checked, keep going
		// Else, bring the principal sections dialog.

		// 4. Otherwise, just selectChecked()

		object =
			object ||
			this.ms[this.ms.preferences.displayObjects].find((object: ViennaObject) => object.classification === classification);

		classification = classification || object.classification;

		// 1. Checks the corresponding section.
		object.checked = true;

		if (object.auxiliaryOf) {
			// 2. If this section has one principal, also check this principal.
			if (object.auxiliaryOf.length === 1) {
				// console.info(`Section has one auxiliary.`)

				let principal: ViennaObject = this.ms.allSections.find(
					(s) => s.classification === object.auxiliaryOf[0]
				);

				if (!principal || (!principal.checked && !principal.selected)) {
					// console.info(`Checking principal section  ${principal.name}`)

					if (showToast) {
						principal.autoChecked = true;
						let msg =
							this.ms.translate("is auxiliary of") +
							` "${principal.classification} - ${principal.name}". ` +
							this.ms.translate("checked automatically");
						this.ms.toast({ msg, timeout: 8000 });
					}

					// console.log(`Recursively checking ${principal.checked}`)

					this.checkObject({ classification: object.auxiliaryOf[0] }); // recursive.
				} else {
					// console.info(`This section has one principal, it's already checked or selected, all good.`)
				}

			} else {

				// 3. We have more than one principal

				// Looking if at least one of these sections is already checked or selected
				let isAllSelectedAndChecked: string[] = this.ms[this.ms.preferences.displayObjects]
					.filter((s) => s.checked || s.selected)
					.map((s) => s.classification);

				if (
					!isAllSelectedAndChecked.some((classification) =>
						object.auxiliaryOf.includes(classification)
					)
				) {
					// None of the auxiliaries is checked or selected.
					// console.info(`This section has many principals, none of them is checked or selected. Bringing up the principals dialog.`)

					for (let s of this.ms[this.ms.preferences.displayObjects]) {
						s.inModal = object.auxiliaryOf.includes(s.classification);
					}

					let bestPrincipal: ViennaObject = this.ms[this.ms.preferences.displayObjects].find((s) => s.inModal); // The first result will necessarily the one with the best score, because all sections are sorted by score.

					// console.log(`Auto-checking the best principal in dialog : `, bestPrincipal)

					this.checkObject({ object: bestPrincipal }); // recursive. to save some time

					return this.ms.toggleModal("PrincipalSections");
				} else {
					// console.info(`This section has many principals, at least one of them is already checked or selected, all good`)
				}
			}
		}

		// console.log(`${l}After checking (checked===true) : `, structuredClone(object));

		this.selectChecked();
	}

	clearFilter() {
		this.columnFilter = "";
		this.filterResults();
	}

	computeStars(score: number): number {
		if (score > 45) return 5;
		if (score > 25) return 4;
		if (score > 10) return 3;
		if (score > 5) return 2;
		if (score >= minScore) return 1;
		return 0;
	}

	filterResults() { // when typing something in the filter at the top of the column - I guess it could be integrated to listToDisplay below

		const l = `mas.filterResults() - `


		if (!this.ms.selectedCategory) {
			// console.log(`filterResults() - no selected category, gracefully exiting.`)
			return;
		}

		// if (this.columnFilter.length < 2) return; // not enough to trigger filtering

		let filterWithoutDiaritics = this.columnFilter
			.toLowerCase()
			.replace(/[\u0300-\u036f]/g, ""); // removing diacritics

		if (!!"".normalize) {
			filterWithoutDiaritics = filterWithoutDiaritics.normalize("NFD");
		}

		for (let object of this.ms[this.ms.preferences.displayObjects]) {
			const isFromCurrentCategory = this.ms.selectedCategory?.classification === object.classificationArray[0];
			if (!isFromCurrentCategory) continue;
			object.hidden = !object.nameLower.includes(filterWithoutDiaritics);
		}
	}

	listToDisplay({
		properties = [],
		inverse = false
	}): ViennaObject[] {

		const l = `MAS.listToDisplay() - `

		// Utility that returns a partial sections array (for the principal sections dialog, for instance)

		// Example : listToDisplay({ properties: ['selected'] }) returns only objects with selected===true
		// Example : listToDisplay({ properties: ['selected','inModal'] }) returns only objects with selected===true and inModal===true

		// Example : listToDisplay({ properties: ['hidden'], inverse:true }) returns only objects with hidden===false

		// console.log(`${l}ms.preferences = `, structuredClone(this.ms.preferences));
		// console.log(`${l}this.ms[${this.ms.preferences.displayObjects}] = `, structuredClone(this.ms[this.ms.preferences.displayObjects]));

		// console.log(`${l}Filtering ms[${this.ms.preferences.displayObjects}] = `, this.ms[this.ms.preferences.displayObjects]);

		let filtered: ViennaObject[] = this.ms[this.ms.preferences.displayObjects]
			.filter((object: ViennaObject) => {

				const isFromCurrentCategory = this.ms.selectedCategory?.classification === object.classificationArray[0];

				// console.log(`${l}${object.classificationArray} is from current category (${this.ms.selectedCategory?.classification}) ? ${isFromCurrentCategory}`);

				if (!isFromCurrentCategory) return false; // First quick filter

				if(object.objectType==="section" && object.classification?.endsWith(".0")){

					/*
						This is a dummy section.
						tyhe Vienna classificaiton has divisions with no section, like 28.1, 28.3, etc.
						BUT the classifier does not support divisions, it only works with sections...
						So I have created dummy sections by adding a .0 at the end.

						28.1	INSCRIPTIONS IN ARABIC CHARACTERS
						  |
						  -->	28.1.0	INSCRIPTIONS IN ARABIC CHARACTERS

						Result : the classifier sends me a rating for 28.1.0, rating which will be added to the parent division (28.1). So yay, I have my lone division rating.
						Now I don't need to actually display this dummy section, I filter it out here.
					*/

					console.log(`${l}Filtering out dummy section ${object.classification} "${object.name.substring(0,50)}"`);

					return false
				}

				let hasAllProperties: boolean = properties.every((property: string) => object[property]);

				if (inverse) hasAllProperties = !hasAllProperties;

				// console.log(`${l}object = `, object);
				// console.log(`${l}${properties} hasAllProperties ? ${hasAllProperties}`);

				return hasAllProperties
			});

		filtered.sort((a, b) => a.score > b.score ? -1 : 1)

		// console.log(`${l}arguments = `, arguments[0], "Returning : ", filtered)

		return filtered;
	}

	preselect() {
		// console.log(`preselect() - Auto checking suggested sections`)

		for (let section of this.ms[this.ms.preferences.displayObjects]) {
			if (!section.suggested) continue;

			if (
				this.selectedSections.find(
					(s) => s.classification === section.classification
				)
			)
				continue;

			this.selectedSections.push(section); // I want to push them to an independent array for drag-drop sorting
			section.selected = true;

			// console.log(`preselect() - selecting ${section.name}`)

			// If it is an auxiliary, automatically selecting the best principal section

			if (section.auxiliaryOf) {
				let principals: ViennaObject[] = this.ms[this.ms.preferences.displayObjects].filter((s) =>
					section.auxiliaryOf.includes(s.classification)
				);

				principals.sort((a, b) => (a.score > b.score ? -1 : 1));

				let bestPrincipal = principals.pop();

				if (
					!this.selectedSections.find(
						(s) => s.classification === bestPrincipal.classification
					)
				) {
					// console.log(`Auto - selecting principal section : ${bestPrincipal.name}`)
					this.selectedSections.push(bestPrincipal);
					bestPrincipal.selected = true;
				}
			}
		}
	}

	resetResults(clearSelection = true) {
		const l = `MAS.mas.resetResults - `;

		// console.time(`${l}Reset took`);

		this.columnFilter = "";

		if (this.ms.selectedCategory) {
			this.ms.back();
		}

		// console.log(`${l}this.ms.preferences.lang = `, this.ms.preferences.lang)

		this.ms.allCategories = this.ms.allCategories.map((category) => {
			["checked", "suggested", "visited"].forEach(key => delete category[key]);
			category.score = 0;
			category.stars = [];
			category.objectType = "category";
			return category;
		});

		let toDelete = [
			"checked",
			"hidden",
			"inModal",
			"autochecked",
			"suggested",
			"visited",
		];

		if (clearSelection) {
			toDelete.push("selected");
			this.selectedSections = [];
		}

		this.ms.allSections = this.ms.allSections.map((section) => {
			toDelete.forEach((key) => delete section[key]);
			section.score = 0;
			section.stars = [];
			section.objectType = "section"; // yeah because now I mix sections and divisions together
			return section;
		});

		this.ms.allDivisions = this.ms.allDivisions.map((division) => {
			toDelete.forEach((key) => delete division[key]);
			division.score = 0;
			division.stars = [];
			division.objectType = "division"; // yeah because now I mix sections and divisions together
			return division;
		});

		// No need to reset allDivisionsAndSections. The array will be regenerated by concatenating divisions and sections, after scoring them, in buildResults()

		// console.timeEnd(`${l}Reset took`); // 10ms
	}

	selectChecked() {

		for (let object of this.ms[this.ms.preferences.displayObjects]) {
			if (!object.checked) continue;
			// console.log(`pushing ${section.name} to selected sections`)
			this.selectedSections.push(object); // I want to push them to an independent array for drag-drop sorting
			object.checked = false;
			object.selected = true;
		}

		// this.filterResults(); But why filter results here?

		window.dispatchEvent(new Event("added to selection"));
	}

	async sendImageData(clearSelection = true) {
		// Called from imagedrop.component

		if (!this.base64.length) return;

		// console.log(`calling image API`)

		this.resetResults(clearSelection);

		let url =
			"/image-classification/" +
			(mapping_version[this.ms.preferences.viennaVersion] || "vienna8");

		let res: ImageClassificationResponse;

		try {
			res = await this.call(url, {
				imageBase64: this.base64,
			});
		} catch (error) {
			// API call failed - check if we're in dev mode and can use mock data
			if (this.ms.isDevMode) {
				console.log("API call failed in dev mode, loading mock response...");
				try {
					// Load mock response dynamically
					const mockResponse = await fetch('assets/mockResponse.json');
					if (mockResponse.ok) {
						res = await mockResponse.json();
						console.log("Mock response loaded successfully");
					} else {
						throw new Error("Could not load mock response");
					}
				} catch (mockError) {
					console.error("Failed to load mock response:", mockError);
					// Fall back to the original offline behavior
					res = null;
				}
			} else {
				// Not in dev mode, use original error handling
				res = null;
			}
		}

		this.ms.layout = "pastilles";

		if (!res) {
			// Probably fell in the .catch( or mock loading failed

			// Even if the classification API can't be reached, we must still be able to manually classify. The app behaves slightly differently if the API is offline.
			this.ms.apiOffline = true;

			this.ms[this.ms.preferences.displayObjects].sort((a, b) =>
				a.classification > b.classification ? -1 : 1
			);

			return;
		}

		this.ms.apiOffline = false;
		// console.log(`got image API response`)

		this.res = res; // in case of language change, so we don't need to call the API again, we can just use the cached results

		// console.log(`SendImageData() res = `, res)

		setTimeout(() => {
			this.buildResults();
			this.suggest();

			if (this.ms.preferences.preselect) {
				// Mark sections as preselected (bulkChecked) based on mode
				if (this.ms.preferences.selectedMode === '/productionmode') {
					this.suggestCustom();
				} else {
					this.preselect();
				}
			}
		});
	}

	suggest() {

		const l = `mas.suggest() - `

		let suggestedCount: number = 0;

		for (let object of this.ms[this.ms.preferences.displayObjects]) {

			if (object.score >= 10) {
				// console.log(`${l}suggesting ${object.objectType} ${object.classification} "${object.name}" (score=${object.score})`);
				object.suggested = true;
				suggestedCount++;
			}

			object.stars = Array(this.computeStars(object.score)); // generating an array of length 5 so it is iterable to draw stars
		}

		// console.log(`Suggesting categories...`)

		// We want : 1 minimum, 8 maximum, score >= 0.1
		// In pastille mode, categories are not sorted by score but by classification. The first three are not the most relevant. If I want the first 8 best scored, I need to work a bit

		suggestedCount = 0;
		let categoriesScores = this.ms.allCategories.map((c) => ({
			classification: c.classification,
			score: c.score,
		}));

		categoriesScores.sort((a, b) => (a.score > b.score ? -1 : 1)); // which I can't do directly on the categories themselves (not to be sorted by score)

		// console.log(`categoriesScores (sorted by score) = `, categoriesScores)

		for (let categoriesScore of categoriesScores) {
			if (categoriesScore.score >= minScore || suggestedCount === 0) {
				let toSuggest = this.ms.allCategories.find(
					(c) => c.classification === categoriesScore.classification
				);
				toSuggest.stars = Array(this.computeStars(toSuggest.score)).fill(0); // generating an array of length 1 to 5 so it is iterable to draw stars
				toSuggest.suggested = true;
				// console.log(`Suggesting category ${toSuggest.name} - score = ${toSuggest.score} (should equal ${categoriesScore.score})- suggestedCount = ${suggestedCount}`)
				suggestedCount++;
			}
			if (suggestedCount === 7) break;
		}
	}

	suggestCustom() {
		const l = `mas.suggestCustom() - `;

		// For production mode: pre-select sections based on user preference
		const mode = this.ms.preferences.preselectMode;
		const count = this.ms.preferences.preselectCount;
		const threshold = this.ms.preferences.preselectThreshold;
		let sectionsToPreselect: ViennaObject[] = [];

		// Get all sections with score > 0, sorted by score descending
		const scoredSections = this.ms[this.ms.preferences.displayObjects]
			.filter(section => section.score !== undefined && section.score !== null && section.score > 0)
			.sort((a, b) => (b.score || 0) - (a.score || 0));

		// Determine which sections to preselect based on mode
		switch (mode) {
			case "firstN":
				sectionsToPreselect = scoredSections.slice(0, count);
				break;

			case "all":
				sectionsToPreselect = scoredSections;
				break;

			case "none":
				sectionsToPreselect = [];
				break;

			case "aboveScore":
				sectionsToPreselect = scoredSections.filter(section => section.score >= threshold);
				break;

			default:
				sectionsToPreselect = scoredSections.slice(0, 10);
		}

		// Mark sections as selected (will show in selectedSections)
		for (let section of sectionsToPreselect) {
			if (!this.selectedSections.find(s => s.classification === section.classification)) {
				this.selectedSections.push(section);
				section.selected = true;
			}
		}

		// console.log(`${l}Preselected ${sectionsToPreselect.length} sections using mode '${mode}'`);
	}

	toggle(object: ViennaObject) {

		const l = `mas.toggle() - `

		// console.log(`${l}Toggling `, structuredClone(object));

		if (object.selected) {
			this.unselect(object);
		} else {
			this.checkObject({ object, showToast: true });
		}
	}

	unselect(section: ViennaObject, skipConfirmation: boolean = false): void {
		// Hmmm, I need to check if it's not a principal section first

		// console.log(`unselect()`)

		for (let selected of this.selectedSections) {
			if (
				!this.ms.display.dialogPrincipalSections &&
				selected.auxiliaryOf &&
				selected.auxiliaryOf.includes(section.classification)
			) {
				if (
					!skipConfirmation &&
					!skipConfirmation &&
					!confirm(
						this.ms
							.translate("principal section remove warning")
							.replace("%s", selected.name)
					)
				)
					return;
			}
		}

		section.selected = false;
		section.checked = false;

		this.selectedSections = this.selectedSections.filter(
			(s) => s.classification !== section.classification
		);

		// this.filterResults(); Uh? Why filter the results here? 
	}

	clearAll() {
		// Clear all selected sections
		this.selectedSections.forEach(section => {
			section.selected = false;
			section.checked = false;
		});
		this.selectedSections = [];
	}

	selectAll() {
		// Select all available categories/sections
		if (this.ms.allCategories) {
			this.ms.allCategories.forEach(category => {
				if (!this.selectedSections.find(s => s.classification === category.classification)) {
					this.selectedSections.push(category);
					category.selected = true;
					category.checked = false;
				}
			});
		}
	}
}
